<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="物流配送方式" name="name"></c-form-item>
					<!-- <c-form-item type="select" label="是否支持到付" name="is_collect" :options="isCollect"></c-form-item> -->
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_logistics_company_add" color="sys" @click="createLogisticsCompany">新增配送方式</c-button>
			</m-operate>
			
			<c-table ref="table" code="logistics_company_list">
				<c-table-column
					label="配送方式代码"
					name="code"
					width="110"
				>
				</c-table-column>
				
				<c-table-column
					label="物流配送方式"
					name="name"
					width="140"
				>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:red">禁用</span>
                        <span v-if="data.state == 2" style="color:green">启用</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="创建日期"
					name="create_date"
					width="140"
				>
				</c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					name="sort_id"
					power="b_logistics_company_sort"
					@sort="sortHandle"
				>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="160"
				>
					<template v-slot="{data}">
							<c-table-button power="b_logistics_company_edit" @click="edit(data)">编辑</c-table-button>
							<c-table-button power="b_logistics_company_del" v-if="data.state == 1" @click="del(data)">删除</c-table-button>
							<c-table-button power="b_logistics_company_state" v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
							<c-table-button power="b_logistics_company_state" v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="logisticsCompanyEdit" :title="editState ? '编辑配送方式' : '新增配送方式'" width="600" @resolve="submitLogisticsCompany">
			<c-form ref="logisticsCompanyForm">
				<c-form-item type="input" label="配送方式代码" name="code" required></c-form-item>
				<c-form-item type="input" label="物流配送方式" name="name" required></c-form-item>
				<!-- <c-form-item type="select" label="是否到付" name="is_collect" :options="isCollect" required></c-form-item> -->
				<c-form-item type="hidden" name="is_collect" ></c-form-item>
				<c-form-item type="radio" label="是否启用" name="state" :options="stateType" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_logistics_company',
		
		data() {
			return {
				isCollect: [{
					name: '不支持',
					value: 0
				},{
					name: '支持',
					value: 1
				}],

				stateType: [{
					name: '禁用',
					value: 1
				},{
					name: '启用',
					value: 2
				}],

				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/logistics_company/list',
					data
				});
			},

			sortHandle(row, type, next) {
				//row.prev() 上一行数据
				//row.next() 下一行数据
				let submitData ={};
				if(type=='top' || type=='bottom'){
					submitData.type = type;
					submitData.id = row.data.id;
				}
				if(type=='up'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.prev().data.id;
				}
				if(type=='down'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.next().data.id;
				}
				this.request({
					url: '/logistics_company/sort',
					data: submitData,
					loading: true,
					success: data => {
						if (type == 'top' || type == 'bottom') {
							this.$refs.table.update();
						} else {
							next();
						}
					}
				});
			},

			createLogisticsCompany() {
				this.editState = false;
				this.$refs.logisticsCompanyForm.clear();
				this.$refs.logisticsCompanyForm.set({"is_collect":0});
				this.$refs.logisticsCompanyEdit.open();
			},
			
			edit(val) {
				this.editState = true;
				this.$refs.logisticsCompanyForm.set(val);
				this.$refs.logisticsCompanyEdit.open();
			},

			del(val) {
				this.$confirm({
					text: '删除配送方式后，各商家对应的该配送方式的引用也将被删除，请谨慎操作！是否确定删除【'+val.name+'】？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/logistics_company/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			updateState(type,val) {
        var msg = "";
        if (type==2){
          msg = '确定要启用【'+val.name+'】吗？';
        }else {
          msg = '禁用后，所有引用该配送方式的商家将不再允许使用该公司，是否确认禁用【'+val.name+'】？';
        }
				this.$confirm({
          text:msg,  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/logistics_company/state',
							data: {id:val.id,state:type},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			submitLogisticsCompany(stop) {
				stop();
				let submitUrl = '/logistics_company/add';
				if(this.editState){
					submitUrl = '/logistics_company/edit';
				}
				this.$refs.logisticsCompanyForm.submit({
					url: submitUrl,
					rule: {
						code: [{
							type: 'empty',
							word: '请填写配送方式代码'
						}],
						
						name: [{
							type: 'empty',
							word: '请填写物流配送方式'
						}],

						// is_collect: [{
						// 	type: 'empty',
						// 	word: '请选择是否到付'
						// }],

						state: [{
							type: 'empty',
							word: '请选择是否启用'
						}]
					},
					dataFormatter: data => {
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.logisticsCompanyEdit.close();
					},
				});
			}
		}
	}
</script>